module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"parameters\">\n    <div class=\"flex\">\n        <div class=\"flex-item padding__ltrb-10\">\n            <label>\n                Хозяйство\n            </label><br/>\n            <control type=\"popup-select\" target=\"parameters.farms\"\n                     source=\"farmsSource\"\n                     filter=\"")
    ; __append(escapeFn( JSON.stringify(widget.farmsFilter) ))
    ; __append("\"\n                     html-placeholder=\"Фильтр по хозяйству\"\n                     title-key=\"name\"\n                     value-key=\"id\"\n                     multiple/>\n        </div>\n        <div class=\"flex-item padding__ltrb-10\">\n            <label>\n                Год\n            </label><br/>\n            <control type=\"multi-select\" target=\"parameters.years\"\n                     source=\"yearsSource\"\n                     html-placeholder=\"Фильтр по году\"\n                     title=\"name\"\n                     value=\"id\"\n                     adjust-value=\"toInt\"\n                     multiple/>\n        </div>\n    </div>\n    <hr/>\n    <button on-click=\"onCreateClick\" data-format=\"")
    ; __append(escapeFn( Reports.Format.Html ))
    ; __append("\">Создать</button>\n    <button on-click=\"onDownloadExcelClick\">Скачать в формате Excel</button>\n</div>\n")
  }
  return __output.join("");

}